import { ICheckBehavior } from "./ICheckBehavior";
import { PatientProfileCheckKinds } from "./PatientProfileCheckKinds";

export class CheckScores {
  constructor(public on: number, public off: number) {}

  clone(): CheckScores {
    return new CheckScores(this.on, this.off);
  }

  static from(source: { on: number, off: number }): CheckScores {
    return new CheckScores(source.on, source.off);
  }

  static to(source: CheckScores): { on: number, off: number } {
    return {
      on: source.on,
      off: source.off,
    };
  }
}

export class CheckBehavior {
  constructor(
    public isChecked: boolean         = false,
    public isMultiCheckable: boolean  = false,
    public score: CheckScores = new CheckScores(0, 0),
    public patientProfileKinds: PatientProfileCheckKinds = PatientProfileCheckKinds.None,
    public pastedTextToCheck: string = "",
    public isGroupScopePage: boolean = true,
  ) {
  }

  clone(): CheckBehavior {
    return new CheckBehavior(
      this.isChecked,
      this.isMultiCheckable,
      this.score.clone(),
      this.patientProfileKinds,
      this.pastedTextToCheck,
      this.isGroupScopePage);
  }

  static from(source: ICheckBehavior): CheckBehavior {
    return new CheckBehavior(
      source.isChecked,
      source.isMultiCheckable,
      CheckScores.from(source.score),
      source.patientProfileKinds,
      source.pastedTextToCheck,
      source.isGroupScopePage);
  }

  static to(source: CheckBehavior): ICheckBehavior {
    return {
      isChecked: source.isChecked,
      isMultiCheckable: source.isMultiCheckable,
      score: CheckScores.to(source.score),
      patientProfileKinds: source.patientProfileKinds,
      pastedTextToCheck: source.pastedTextToCheck,
      isGroupScopePage: source.isGroupScopePage,
    };
  }
}
